import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=35cdb20a&scoped=true&"
import script from "./InputBox.vue?vue&type=script&lang=ts&"
export * from "./InputBox.vue?vue&type=script&lang=ts&"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=35cdb20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cdb20a",
  null
  
)

export default component.exports